import { RulesFilters } from '@/shared/filters/rules-filters';
import { VueClass } from 'vue-class-component/lib/declarations';

export const configFilters = (vueInstance: VueClass<any>) => {
  vueInstance.filter('conditionTypeFilter', RulesFilters.conditionTypeFilter);
};
